import React, { useMemo, useState } from "react";
import classes from "./productDescription.module.scss";

const MANUFACTURER_LINES = [
  "Sunny Diamonds Pvt Ltd,",
  "3rd & 4th Floor, 66/3605 & 66/3606, Rajaji Road, Kochi - 682035,",
  "Kerala, India.",
  "CIN: U36911KL2008PTC023236",
];

const hasValue = (value) =>
  value !== null && value !== undefined && value !== "";

const formatText = (value) => {
  if (!hasValue(value)) return "-";
  if (typeof value === "number") return value;
  return String(value).replaceAll("_", " ").replaceAll("-", " ").toUpperCase();
};

const ProductDescription = ({ item }) => {
  const [openIndex, setOpenIndex] = useState(0);

  const sections = useMemo(() => {
    if (!item || typeof item !== "object") return [];

    const output = [
      {
        title: "Metal Details",
        rows: [
          {
            label: "Metal Weight",
            value: hasValue(item.metal_weight) ? `${item.metal_weight} (gm)` : "-",
          },
          { label: "Setting Type", value: formatText(item.product_setting) },
          { label: "Metal Purity", value: formatText(item.metal_purity) },
          { label: "Metal Type", value: formatText(item.metal_type) },
          { label: "Metal Color", value: formatText(item.color) },
        ],
      },
    ];

    if (Number(item.diamond_count) !== 0) {
      output.push({
        title: "Diamond Details",
        rows: [
          { label: "Diamond Count", value: formatText(item.diamond_count) },
          { label: "Diamond Clarity", value: formatText(item.diamond_clarity) },
          { label: "Diamond Color", value: formatText(item.diamond_color) },
          { label: "Diamond Carat", value: formatText(item.diamond_carat) },
          { label: "Diamond Cut", value: formatText(item.diamond_cut) },
        ],
      });
    }

    if (Number(item.gemstone_price) !== 0) {
      output.push({
        title: "Gemstone Details",
        rows: [
          { label: "Gem Type", value: formatText(item.gemstone_type) },
          { label: "Gem Carat", value: formatText(item.gemstone_carat) },
          { label: "Gem Count", value: formatText(item.gemstone_count) },
        ],
      });
    }

    output.push({
      title: "Manufactured by",
      customContent: (
        <div className={classes.manufacturer_content}>
          {MANUFACTURER_LINES.map((line) => (
            <p key={line}>{line}</p>
          ))}
          <p className={classes.origin_block}>
            <strong>Country of Origin</strong>
            <p>India</p>
          </p>
        </div>
      ),
    });

    return output;
  }, [item]);

  if (!sections.length) return null;

  return (
    <section className={classes.product_description}>
      {sections.map((section, index) => {
        const isOpen = openIndex === index;
        const panelId = `product-description-panel-${index}`;

        return (
          <div className={classes.accordion_item} key={section.title}>
            <button
              type="button"
              className={`${classes.accordion_trigger} ${isOpen ? classes.show : ""}`}
              onClick={() => setOpenIndex(isOpen ? -1 : index)}
              aria-expanded={isOpen}
              aria-controls={panelId}
            >
              {section.title}
            </button>
            {isOpen && (
              <div id={panelId} className={classes.accordion_panel}>
                {section.customContent ? (
                  section.customContent
                ) : (
                  <div className={classes.details_grid}>
                    {section.rows.map((row) => (
                      <React.Fragment key={row.label}>
                        <div className={classes.details_label}>{row.label}</div>
                        <div className={classes.details_value}>{row.value}</div>
                      </React.Fragment>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </section>
  );
};

export default ProductDescription;
